import { render, staticRenderFns } from "./Changes_panel.vue?vue&type=template&id=75a5027a&scoped=true&"
import script from "./Changes_panel.vue?vue&type=script&lang=js&"
export * from "./Changes_panel.vue?vue&type=script&lang=js&"
import style0 from "./Changes_panel.vue?vue&type=style&index=0&id=75a5027a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a5027a",
  null
  
)

component.options.__file = "Changes_panel.vue"
export default component.exports